<!--Main-->
<template>
  <div class="fn-layout-vertical-conatiner app-container" style="height: calc(100%);">
    <!--工具条-->
    <div class="fn-layout-vertical-form">
      <div class="vertical-form-cont fn-border-bottom">
        <!-- -->
        <slot name="top-form"></slot>
      </div>
    </div>
    <div class="fn-layout-vertical-operation"  v-if="operation">
      <div class="fn-layout-vertical-operation-item">
        <slot name="left-btn"></slot>
      </div>
      <div class="fn-layout-vertical-operation-item">
        <slot name="right-btn"></slot>
      </div>
    </div>
    <!--列表-->
    <div class="fn-layout-vertical-table" style="height: calc(100%);" ref="fnLayoutTable">
      <slot name="tab-body"></slot>
    </div>
    <!---->
    <div class="fn-layout-vertical-pagination fn-border-top"
         style="justify-content: space-between">
      <slot name="bottom-page"></slot>
    </div>
    <!--    -->
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "index",
    props:{
      operation:{
        type:Boolean,
        default:true
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/components/layout-body.vue